export default "__VITE_ASSET__CxsKFNXP__"